import { PUBLIC_MARKETING_HOME_PATH } from "@/lib/publicHomeEntry";
import { BLOG_COLLECTION_PATH } from "@/lib/seo/metadata";

const stripTrailingSlash = (pathname: string) => pathname.replace(/\/$/, "") || "/";

export type PublicShellPlaceholderSurface = "home" | "aramlas-home" | "mentor" | "white";

const WHITE_BG_ROUTES = new Set(["/tamogatas", BLOG_COLLECTION_PATH, "/rolunk"]);
const WHITE_BG_PREFIXES = ["/p/"] as const;

const MENTOR_BG_ROUTES = new Set([
  PUBLIC_MARKETING_HOME_PATH,
  "/mentor",
  "/mentor/kreditek",
  "/ingyenes-tartalmak",
  "/courses",
  "/gabor",
  "/kuldetes",
  "/ujdonsagok",
  "/events",
  "/jegyzeteim",
]);
const MENTOR_BG_PREFIXES = ["/courses/", "/events/"] as const;

const matchesPrefix = (pathname: string, prefixes: readonly string[]) =>
  prefixes.some((prefix) => pathname.startsWith(prefix));

export const getPublicShellPlaceholderSurface = (
  pathname: string,
): PublicShellPlaceholderSurface | null => {
  const normalized = stripTrailingSlash(pathname);

  if (normalized === "/") {
    return "home";
  }

  if (normalized === "/aramlas/home") {
    return "aramlas-home";
  }

  if (WHITE_BG_ROUTES.has(normalized) || matchesPrefix(normalized, WHITE_BG_PREFIXES)) {
    return "white";
  }

  if (MENTOR_BG_ROUTES.has(normalized) || matchesPrefix(normalized, MENTOR_BG_PREFIXES)) {
    return "mentor";
  }

  return null;
};

export const shouldUseMentorShellPlaceholder = (pathname: string): boolean =>
  getPublicShellPlaceholderSurface(pathname) !== null;
